import React from 'react';
import Base from './Base';

type ButtonProps = React.ComponentProps<typeof Base>;

const Primary: React.FC<ButtonProps> = ({ className, ...rest }) => {
    const classes = ['btn--primary', className].filter(Boolean).join(' ');
    return <Base className={classes} {...rest} />;
};

export default Primary;


